// Sidebar navigation map for the ICIB Admin Console.
// `story` cross-references the user story it implements in
// BrandonUserStoryAPI.md, matching the sample UI's nav labelling.
export const NAV = [
  {
    section: 'People enrolled',
    items: [
      { path: '', label: 'Overview', story: '' },
      { path: 'employees', label: 'Employees', story: 'ICIB-01' },
    ],
  },
  {
    section: 'Movements',
    items: [
      { path: 'intake', label: 'Enrolment', story: 'ICIB-02' },
      { path: 'pending-intake', label: 'Pending enrolment', story: 'ICIB-13' },
      { path: 'confirmations', label: 'Enrolment status', story: 'ICIB-04' },
      { path: 'followup', label: 'Follow-up tasks', story: 'ICIB-03' },
    ],
  },
  {
    section: 'Configuration',
    items: [
      { path: 'groups', label: 'Companies', story: 'ICIB-09' },
      { path: 'users', label: 'User accounts', story: 'ICIB-08' },
      { path: 'forms', label: 'Enrolment forms', story: 'ICIB-10' },
      { path: 'products', label: 'Subsidised product level set up', story: 'ICIB-11' },
    ],
  },
];
